import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface ScaleIndicationProps {
  scaleId: string;
  unit: string | null;
}

export const ScaleIndication: React.FC<ScaleIndicationProps> = ({ scaleId, unit }) => {
  const { t } = useTranslation();

  const scaleIndication = useSelector((state: RootState) => {
    if (!scaleId) {
      return null;
    }

    return state.scaleIndications.indications[scaleId];
  });

  const getMeasurementValue = (): string => {
    return scaleIndication?.value || scaleIndication?.value === 0 ? scaleIndication?.value.toString() : '---';
  };

  return (
    <div className="flex flex-column align-items-center justify-content-center p-4 border-round-lg surface-card shadow-2 h-full">
      <div className="text-center mb-3">
        <h3 className="text-primary m-0 font-semibold">{t('scaleInfo.current_indication')}</h3>
      </div>
      <div className="text-center">
        <span className="text-8xl font-bold text-900" style={{ letterSpacing: '0.05em' }}>
          {getMeasurementValue()}
        </span>
        {unit && scaleIndication && <span className="text-4xl text-600 font-medium ml-2">{unit}</span>}
      </div>
    </div>
  );
};
